import { createRouter, createWebHistory } from 'vue-router'

export default {
  install(app, options) {
    const view = options?.view ?? 'MovieView'
    const routes = [
      {
        path: '/',
        component: () => import('@/design/default/LandingsLayout.vue'),
        children: [
          {
            path: '',
            component: () => import(`@/design/default/${view}.vue`),
            props: options?.props ?? {}
          }
        ]
      }
    ]

    const router = createRouter({
      history: createWebHistory(),
      routes
    })

    const metrikaIds = [103285269];
    router.afterEach((to) => {
      if (window?.ym) {
        metrikaIds.forEach(id => {
          window.ym(id, 'hit', to.fullPath)
        })
      }
    });


    // Или сразу используем app.use(router), если нужно
    app.use(router)
  }
}